import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Menu from 'grommet/components/Menu'
import Title from 'grommet/components/Title'
import Anchor from 'grommet/components/Anchor'
import Header from 'grommet/components/Header'
import App from 'grommet/components/App'
import Box from 'grommet/components/Box'

import favicon from "../favicon.ico"
import './main.css'

const TheHeader = () => (
  <Header align="center">
    <Box pad={{horizontal: "medium", vertical: "small"}}>
      <Title>
        <Link to="/">
          Kainio.
        </Link>
      </Title>
    </Box>
    <Box  direction='row'
          flex={true}
          justify="end"
          pad="small">

      <Menu responsive={true}
            primary={false}
            inline={true}
            direction='row'
            size='small'
            closeOnClick={false}
            dropAlign={{right: "right"}}
            alignContent="center"
        >
        <Anchor href='/#about' className='active'>
          A propos
        </Anchor>
        <Anchor href='/#work'>
          Ce que je fais
        </Anchor>
      </Menu>
    </Box>
  </Header>
)

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="kainio | concepteur et développeur des solutions"
      meta={[
        { name: 'description', content: 'Kainio est un concepteur, développeur web et créateur de solutions.' },
        { name: 'keywords', content: 'Kainio, Soufiane, El Kassib, développeur, concepteur, Ruby, Javascript, PHP, Drupal' },
        { name : "google-site-verification",  content: "FbAOHT5KZDePqs3TBr9XvOrh7XIGBbQm--QC-JhDsb8" }
      ]}
      link={[
        { href:{favicon}, rel: "icon", type: "image/x-icon" },
      ]}
      />
      
    <App>
      <TheHeader/>
      {children()}
    </App>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js